const UI = (() => {
  // Shopify port: stone images live in the theme's flat assets/ dir, so their
  // original "assets/images/stones/x.jpg" paths are remapped to CDN URLs via
  // the map injected by sections/vedic-stone.liquid. Falls back to the raw path
  // when the map is absent (e.g. running the original outside Shopify).
  function assetImg(path) {
    const a = window.__VEDIC_STONE_ASSETS__;
    return (a && typeof a.img === "function") ? a.img(path) : path;
  }

  function transitionScreen(fromId, toId) {
    return new Promise((resolve) => {
      const from = document.getElementById(fromId);
      const to = document.getElementById(toId);

      from.classList.add("screen-exit");

      setTimeout(() => {
        from.classList.remove("screen--active", "screen-exit");
        from.style.display = "none";

        to.style.display = "flex";
        to.classList.add("screen--active", "screen-enter");

        setTimeout(() => {
          to.classList.remove("screen-enter");
          to.scrollTo?.(0, 0);
          window.scrollTo(0, 0);
          resolve();
        }, 400);
      }, 300);
    });
  }

  function populateDateSelects() {
    const yearSelect = document.getElementById("birth-year");
    const monthSelect = document.getElementById("birth-month");
    const daySelect = document.getElementById("birth-day");
    if (!yearSelect) return;

    for (let y = 2010; y >= 1940; y--) {
      const opt = document.createElement("option");
      opt.value = y;
      opt.textContent = y;
      if (y === 1990) opt.selected = true;
      yearSelect.appendChild(opt);
    }

    for (let m = 1; m <= 12; m++) {
      const opt = document.createElement("option");
      opt.value = m;
      opt.textContent = m;
      monthSelect.appendChild(opt);
    }

    updateDays();
    monthSelect.addEventListener("change", updateDays);
    yearSelect.addEventListener("change", updateDays);
  }

  function updateDays() {
    const year = parseInt(document.getElementById("birth-year").value);
    const month = parseInt(document.getElementById("birth-month").value);
    const daySelect = document.getElementById("birth-day");
    const currentDay = parseInt(daySelect.value) || 1;

    const daysInMonth = new Date(year, month, 0).getDate();

    daySelect.innerHTML = "";
    for (let d = 1; d <= daysInMonth; d++) {
      const opt = document.createElement("option");
      opt.value = d;
      opt.textContent = d;
      if (d === Math.min(currentDay, daysInMonth)) opt.selected = true;
      daySelect.appendChild(opt);
    }
  }

  function setupCardSelection(containerSelector, dataAttr, onSelect) {
    const cards = document.querySelectorAll(`${containerSelector} .card--selectable`);
    cards.forEach((card) => {
      card.addEventListener("click", () => {
        cards.forEach((c) => c.classList.remove("card--selected"));
        card.classList.add("card--selected");
        onSelect(card.dataset[dataAttr]);
      });
    });
  }

  function selectCard(containerSelector, dataAttr, value) {
    if (value == null) return false;
    const cards = document.querySelectorAll(`${containerSelector} .card--selectable`);
    let matched = false;
    cards.forEach((card) => {
      if (card.dataset[dataAttr] === String(value)) {
        cards.forEach((c) => c.classList.remove("card--selected"));
        card.classList.add("card--selected");
        matched = true;
      }
    });
    return matched;
  }

  function setupMultiCardSelection(containerSelector, dataAttr, onSelect) {
    const cards = document.querySelectorAll(`${containerSelector} .card--selectable`);
    cards.forEach((card) => {
      card.addEventListener("click", () => {
        card.classList.toggle("card--selected");
        const selected = [];
        cards.forEach((c) => {
          if (c.classList.contains("card--selected")) {
            selected.push(c.dataset[dataAttr]);
          }
        });
        onSelect(selected);
      });
    });
  }

  function selectMultiCards(containerSelector, dataAttr, values) {
    if (!Array.isArray(values) || values.length === 0) return;
    const set = new Set(values.map(String));
    document.querySelectorAll(`${containerSelector} .card--selectable`).forEach((card) => {
      if (set.has(String(card.dataset[dataAttr]))) {
        card.classList.add("card--selected");
      } else {
        card.classList.remove("card--selected");
      }
    });
  }

  function showButton(btnId) {
    const btn = document.getElementById(btnId);
    if (!btn) return;
    btn.classList.remove("btn--hidden");
    btn.classList.add("btn--visible");
  }

  // === Render Result ===

  function paintHeroStoneCircle(circleId, recommendation) {
    const circle = document.getElementById(circleId);
    if (!circle) return;
    circle.style.background = `radial-gradient(circle, ${recommendation.color}44 0%, ${recommendation.color}11 50%, transparent 80%)`;
    const existingImg = circle.querySelector(".hero-stone-image");
    if (existingImg) existingImg.remove();
    if (recommendation.image) {
      circle.classList.add("hero-stone-circle--has-image");
      const img = document.createElement("img");
      img.className = "hero-stone-image";
      img.src = assetImg(recommendation.image);
      img.alt = recommendation.stone;
      circle.appendChild(img);
    } else {
      circle.classList.remove("hero-stone-circle--has-image");
    }
  }

  function fmtYM(ms) {
    const d = new Date(ms);
    const m = String(d.getMonth() + 1).padStart(2, "0");
    return `${d.getFullYear()}/${m}`;
  }

  function renderDashaBlock(vedic, result) {
    const block = document.getElementById("block-dasha");
    if (!block) return;
    if (!vedic || !vedic.nakshatra || !vedic.currentDasha || !vedic.currentDasha.maha) {
      block.style.display = "none";
      return;
    }
    const { nakshatra, currentDasha } = vedic;
    const rashi = result ? result.rashi : null;
    const planetJp = (Astrology && Astrology.PLANET_NAMES_JP) || {};
    const rashiData = rashi && Astrology && Astrology.RASHI_DATA
      ? Astrology.RASHI_DATA.find(r => r.id === rashi.id)
      : null;
    block.style.display = "";

    const rashiValueEl = document.getElementById("dasha-rashi");
    const rashiRow = rashiValueEl ? rashiValueEl.closest(".dasha-row") : null;
    if (rashi && rashiData) {
      if (rashiRow) rashiRow.style.display = "";
      setText("dasha-rashi", `${rashiData.nameJp}（${rashi.name}）`);
      setText("dasha-rashi-lord", planetJp[rashiData.ruler] || rashiData.ruler);
      const reading = (typeof Recommendations !== "undefined" && Recommendations.getRashiReading)
        ? Recommendations.getRashiReading(rashi.id) : "";
      const intro = "ヴェーダ占星術では、生まれた瞬間の月の位置でラーシ（星座）を決めます。これは「ジャンマ・ラーシ（月の星座）」と呼ばれ、太陽の位置で定める西洋占星術の星座とは異なることが多くあります。";
      const paragraphs = [intro, reading].filter(Boolean).map(p => `<p>${p}</p>`).join("");
      setHtml("dasha-rashi-note", paragraphs);
    } else {
      if (rashiRow) rashiRow.style.display = "none";
      setHtml("dasha-rashi-note", "");
    }

    const topPlanetRow = document.getElementById("dasha-top-planet-row");
    if (result && result.topPlanet) {
      if (topPlanetRow) topPlanetRow.style.display = "";
      setText("dasha-top-planet", result.planetNameJp || planetJp[result.topPlanet] || result.topPlanet);
    } else {
      if (topPlanetRow) topPlanetRow.style.display = "none";
    }

    setText("dasha-nakshatra", `${nakshatra.nameJp} 第${nakshatra.pada}パーダ`);
    setText("dasha-nakshatra-lord", planetJp[nakshatra.lord] || nakshatra.lord);

    const md = currentDasha.maha;
    setText("dasha-maha", `${planetJp[md.lord] || md.lord}期`);
    setText("dasha-maha-range", `${fmtYM(md.start)} 〜 ${fmtYM(md.end)}`);

    const antarRow = document.getElementById("dasha-antar-row");
    if (currentDasha.antar) {
      const ad = currentDasha.antar;
      if (antarRow) antarRow.style.display = "";
      setText("dasha-antar", `${planetJp[ad.lord] || ad.lord}期`);
      setText("dasha-antar-range", `${fmtYM(ad.start)} 〜 ${fmtYM(ad.end)}`);
    } else {
      if (antarRow) antarRow.style.display = "none";
    }

    const note = `あなたの月宿「ナクシャトラ」を起点に、120年の惑星期（ヴィムショッタリー・ダシャー）の時計が回り始めます。今あなたが歩んでいるのは ${planetJp[md.lord] || md.lord} の大きな章です。`;
    setText("dasha-note", note);
  }

  // お悩みカード内のサジェスト石ブロック（画像＋石名＋購買訴求文＋コレクションCTA）。
  function renderConcernStone(sug, label) {
    if (!sug || !sug.stone) return "";
    const thumb = sug.image
      ? `<img class="concern-stone__img" src="${assetImg(sug.image)}" alt="${sug.stone}" />`
      : `<span class="concern-stone__img concern-stone__img--blank" style="background:${sug.color}33"></span>`;
    const text = sug.text ? `<p class="concern-stone__text">${sug.text}</p>` : "";
    const cta = sug.collectionUrl
      ? `<a class="concern-stone__cta" href="${sug.collectionUrl}" target="_blank" rel="noopener">${sug.stone}を見る</a>`
      : "";
    return `
      <div class="concern-stone">
        <div class="concern-stone__media">${thumb}</div>
        <div class="concern-stone__body">
          <span class="concern-stone__label">${label}におすすめの石</span>
          <h5 class="concern-stone__name">${sug.stone}<span class="concern-stone__en">${sug.stoneEn || ""}</span></h5>
          ${text}
          ${cta}
        </div>
      </div>`;
  }

  function renderResult(result, recommendation, products, aiReading, wearingGuide, purposes, purposeLabels, recommendedFinger, vedic) {
    // Dasha / Nakshatra block (shown only if Vedic data available)
    renderDashaBlock(vedic, result);

    // Section 1: Hero Stone (on zodiac background) -- both 2D and 3D variants
    paintHeroStoneCircle("hero-stone-circle", recommendation);
    paintHeroStoneCircle("hero-stone-circle-3d", recommendation);
    setText("hero-stone-en", recommendation.stoneEn);
    setText("hero-stone-en-3d", recommendation.stoneEn);
    setText("hero-stone-name", recommendation.stone);
    setText("hero-stone-sub", recommendation.spiritual);
    setText("hero-stone-name-3d", recommendation.stone);
    setText("hero-stone-sub-3d", recommendation.spiritual);

    // Section 2: Personality
    setHtml("result-personality", formatReading(aiReading.personality));

    // Section 3: Timeline
    setHtml("result-past", formatReading(aiReading.past));
    setHtml("result-present", formatReading(aiReading.present));
    setHtml("result-future-year", formatReading(aiReading.future_year || ""));
    setHtml("result-future-beyond", formatReading(aiReading.future_beyond || ""));
    const yearLabel = document.getElementById("label-future-year");
    if (yearLabel) yearLabel.textContent = `${new Date().getFullYear()}年の運勢`;

    // Section 4: Concerns (build blocks dynamically)
    const track = document.getElementById("concerns-track");
    const concernsHeading = document.getElementById("concerns-heading");
    if (track) {
      track.innerHTML = "";
      const ICONS = {
        love: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>',
        career: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/></svg>',
        wealth: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M15 9.5c-.5-1-1.5-1.5-3-1.5-2 0-3 1-3 2.5s1.5 2 3 2.5 3 1 3 2.5-1 2.5-3 2.5c-1.5 0-2.5-.5-3-1.5"/><path d="M12 5.5v1M12 17.5v1"/></svg>',
        health: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22c4-3.5 8-7.5 8-12a5 5 0 0 0-8-4 5 5 0 0 0-8 4c0 4.5 4 8.5 8 12z"/><path d="M12 10v4M10 12h4"/></svg>',
        relationships: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
      };
      let hasContent = false;
      purposes.forEach((key) => {
        const text = aiReading.concerns?.[key] || "";
        if (!text) return;
        hasContent = true;
        const block = document.createElement("div");
        block.className = "result-block";
        block.innerHTML = `
          <div class="concern-header">
            <span class="concern-icon">${ICONS[key] || "✦"}</span>
            <h4 class="concern-title">${purposeLabels[key] || key}</h4>
          </div>
          <div class="result-reading">${formatReading(text)}</div>
          ${renderConcernStone(aiReading.concernSuggestions && aiReading.concernSuggestions[key], purposeLabels[key] || key)}
        `;
        track.appendChild(block);
      });
      if (concernsHeading) concernsHeading.style.display = hasContent ? "" : "none";
    }


    // Section 5: Stone detail (lower section)
    setText("stone-meaning", recommendation.meaning);

    // Stone usage slide
    const usageEl = document.getElementById("stone-usage");
    if (usageEl) usageEl.innerHTML = `<div class="result-reading stone-message">${formatReading(aiReading.stone_usage || "")}</div>`;

    // Wearing guide slide
    const guideEl = document.getElementById("wearing-guide");
    if (guideEl && wearingGuide) {
      const planetJp = result.planetNameJp || "";
      const stoneName = recommendation.stone || "石";
      guideEl.innerHTML = `
        <div class="wearing-guide-grid">
          <div class="wearing-item">
            <span class="wearing-item__label">推奨の指</span>
            <span class="wearing-item__value">${recommendedFinger || "人差し指"}</span>
          </div>
          <div class="wearing-item">
            <span class="wearing-item__label">おすすめ部位</span>
            <span class="wearing-item__value">${wearingGuide.body}</span>
          </div>
          <div class="wearing-item">
            <span class="wearing-item__label">初めてつける日</span>
            <span class="wearing-item__value">${wearingGuide.day}</span>
          </div>
          <div class="wearing-item">
            <span class="wearing-item__label">おすすめ時間帯</span>
            <span class="wearing-item__value">${wearingGuide.time}</span>
          </div>
        </div>
        <div class="result-reading wearing-note">${formatReading(aiReading.wearing_guide || "")}</div>
        <div class="stone-size-note">
          <p class="stone-size-note__title">石のサイズについて</p>
          <p>ヴェーダ占星術の伝統では、身につける主石は大粒であるほど加護が強まるとされてきました。</p>
          <ul>
            <li><strong>エネルギーの容量</strong> ─ 石が大きくなるほど、${planetJp}のエネルギーをより多く宿すとされます。</li>
            <li><strong>共鳴範囲</strong> ─ 肌に触れる面積が広いほど、石の波動が体と長く共鳴し、日々の守護が途切れません。</li>
            <li><strong>意識への働きかけ</strong> ─ 目に映る存在感が、毎日あなたの意識を惑星の加護へと向け続けてくれます。</li>
          </ul>

        </div>
      `;
    }

    // Product links inside stone card
    const stoneProducts = document.getElementById("stone-products");
    if (stoneProducts) {
      stoneProducts.innerHTML = "";
      if (products.length > 0) {
        const divider = document.createElement("div");
        divider.className = "stone-divider";
        stoneProducts.appendChild(divider);

        const cta = document.createElement("p");
        cta.className = "stone-products-cta";
        cta.textContent = `${recommendation.stone}を使ったジュエリーはこちら`;
        stoneProducts.appendChild(cta);
      }
      products.forEach((product) => {
        const url = Recommendations.buildUrl(product.slug);
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.rel = "noopener";
        link.className = "stone-product-link";
        link.textContent = product.name + " →";
        stoneProducts.appendChild(link);
      });
    }

    // Share
    const shareText = `ヴェーダ占星術で私の守護石は【${recommendation.stone}】でした！\n#RAVICHARME #守護石占い`;
    const shareUrl = window.location.href;
    const shareX = document.getElementById("btn-share-x");
    if (shareX) shareX.onclick = () => {
      window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`, "_blank", "noopener,width=550,height=420");
    };
    const shareLine = document.getElementById("btn-share-line");
    if (shareLine) shareLine.onclick = () => {
      window.open(`https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText)}`, "_blank", "noopener");
    };

    // Print
    const btnPrint = document.getElementById("btn-print");
    if (btnPrint) btnPrint.onclick = () => buildAndPrint(recommendation, aiReading, wearingGuide, recommendedFinger, purposes, purposeLabels);
  }

  function buildAndPrint(recommendation, aiReading, wearingGuide, recommendedFinger, purposes, purposeLabels) {
    const container = document.getElementById("vedic-print-summary");
    if (!container) return;

    const logoUrl = (window.__VEDIC_STONE_ASSETS__ || {}).printLogoUrl || "";
    const today = new Date().toLocaleDateString("ja-JP", { year: "numeric", month: "long", day: "numeric" });
    const nl = (s) => (s || "").replace(/\n/g, "<br>");
    // 文末（。）単位で文章を抽出要約（2ページ以内に収めるため）
    const summarize = (s, maxSentences) => {
      const t = (s || "").trim();
      if (!t) return t;
      const sentences = [];
      let cur = "";
      for (const ch of t) {
        cur += ch;
        if (ch === "。") { sentences.push(cur); cur = ""; }
      }
      if (cur.trim()) sentences.push(cur);
      if (sentences.length <= maxSentences) return t;
      return sentences.slice(0, maxSentences).join("");
    };
    const snl = (s, max) => nl(summarize(s, max));

    // お悩み別リーディング
    let concernsHtml = "";
    (purposes || []).forEach((key) => {
      const text = aiReading.concerns?.[key];
      if (!text) return;
      const label = purposeLabels?.[key] || key;
      concernsHtml += `<div class="vps-concern"><div class="vps-concern-label">${label.toUpperCase()}</div><div class="vps-concern-text">${snl(text, 3)}</div></div>`;
    });

    // サポートストーン（お悩み別サジェスト石）
    let stonesHtml = "";
    const PURPOSE_LABEL_MAP = purposeLabels || {};
    (purposes || []).forEach((key) => {
      const sug = aiReading.concernSuggestions?.[key];
      if (!sug || !sug.stone) return;
      const label = PURPOSE_LABEL_MAP[key] || key;
      stonesHtml += `
        <div class="vps-stone-card">
          <div class="vps-stone-card-bar" style="background:${sug.color || "#ab8c52"};"></div>
          <div class="vps-stone-card-purpose">${label}</div>
          <div class="vps-stone-card-name-row">
            <span class="vps-stone-card-dot" style="background:${sug.color || "#ab8c52"};"></span>
            <div>
              <div class="vps-stone-card-name">${sug.stone}</div>
              <div class="vps-stone-card-en">${sug.stoneEn || ""}</div>
            </div>
          </div>
          ${sug.text ? `<div class="vps-stone-card-text">${snl(sug.text, 2)}</div>` : ""}
        </div>`;
    });

    // 身につけ方グリッド
    const wearingGridHtml = wearingGuide ? `
      <div class="vps-wearing-grid">
        <div class="vps-wearing-item"><span class="vps-wearing-label">FINGER</span><span class="vps-wearing-value">${recommendedFinger || "人差し指"}</span></div>
        <div class="vps-wearing-item"><span class="vps-wearing-label">PART</span><span class="vps-wearing-value">${wearingGuide.body || ""}</span></div>
        <div class="vps-wearing-item"><span class="vps-wearing-label">DAY</span><span class="vps-wearing-value">${wearingGuide.day || ""}</span></div>
        <div class="vps-wearing-item"><span class="vps-wearing-label">TIME</span><span class="vps-wearing-value">${wearingGuide.time || ""}</span></div>
      </div>` : "";

    container.innerHTML = `
      <!-- ヘッダー -->
      <div class="vps-header">
        ${logoUrl ? `<img class="vps-logo" src="${logoUrl}" alt="RAVICHARME">` : ""}
        <div class="vps-doc-title">ヴェーダ守護石鑑定書</div>
        <div class="vps-date">${today}</div>
      </div>

      <!-- ゴールドバー -->
      <div class="vps-gold-bar"></div>

      <!-- 守護石ヒーロー -->
      <div class="vps-hero">
        <div class="vps-hero-label">Your Guardian Stone</div>
        <div class="vps-stone-name">${recommendation.stone || ""}</div>
        <div class="vps-stone-en">${recommendation.stoneEn || ""}</div>
        <div class="vps-stone-sub">${recommendation.spiritual || ""}</div>
        <div class="vps-hero-divider">
          <div class="vps-divider-line"></div>
          <div class="vps-divider-gem"></div>
          <div class="vps-divider-line-r"></div>
        </div>
        ${recommendation.meaning ? `<div class="vps-stone-meaning">${snl(recommendation.meaning, 3)}</div>` : ""}
      </div>

      <!-- パーソナリティ -->
      <div class="vps-section">
        <div class="vps-section-header">
          <span class="vps-section-label">あなたの本質</span>
          <span class="vps-section-line"></span>
        </div>
        <div class="vps-text">${snl(aiReading.personality, 3)}</div>
      </div>

      <!-- タイムライン -->
      <div class="vps-section">
        <div class="vps-section-header">
          <span class="vps-section-label">過去・現在・未来</span>
          <span class="vps-section-line"></span>
        </div>
        <div class="vps-timeline-grid">
          <div class="vps-tl-block"><div class="vps-tl-label">PAST / 過去</div><div class="vps-tl-text">${snl(aiReading.past, 3)}</div></div>
          <div class="vps-tl-block"><div class="vps-tl-label">PRESENT / 現在</div><div class="vps-tl-text">${snl(aiReading.present, 3)}</div></div>
          <div class="vps-tl-block"><div class="vps-tl-label">${new Date().getFullYear()}年の運勢</div><div class="vps-tl-text">${snl(aiReading.future_year, 3)}</div></div>
          <div class="vps-tl-block"><div class="vps-tl-label">それ以降の運勢</div><div class="vps-tl-text">${snl(aiReading.future_beyond, 3)}</div></div>
        </div>
      </div>

      ${concernsHtml ? `
      <div class="vps-section">
        <div class="vps-section-header">
          <span class="vps-section-label">お悩み別リーディング</span>
          <span class="vps-section-line"></span>
        </div>
        ${concernsHtml}
      </div>` : ""}

      ${stonesHtml ? `
      <div class="vps-section">
        <div class="vps-section-header">
          <span class="vps-section-label">あなたをサポートする石たち</span>
          <span class="vps-section-line"></span>
        </div>
        <div class="vps-stones-grid">${stonesHtml}</div>
      </div>` : ""}

      <!-- 守護石の使い方 -->
      <div class="vps-section">
        <div class="vps-section-header">
          <span class="vps-section-label">守護石の使い方・身につけ方</span>
          <span class="vps-section-line"></span>
        </div>
        <div class="vps-text">${snl(aiReading.stone_usage, 3)}</div>
        ${wearingGridHtml}
      </div>

      <!-- フッター -->
      <div class="vps-footer">
        <div class="vps-footer-ornament">
          <div class="vps-footer-line"></div>
          <div class="vps-footer-gems"><span></span><span></span><span></span></div>
          <div class="vps-footer-line-r"></div>
        </div>
      </div>
    `;

    // Move to body root so content flows naturally across multiple print pages
    const origParent = container.parentNode;
    const origNext = container.nextSibling;
    document.body.appendChild(container);

    const restore = () => {
      if (origNext) origParent.insertBefore(container, origNext);
      else origParent.appendChild(container);
      container.innerHTML = "";
    };

    const doPrint = () => { window.print(); restore(); };

    // Wait for logo to load before printing (display:none suppresses preload)
    const logo = container.querySelector(".vps-logo");
    if (logo && !logo.complete) {
      logo.addEventListener("load",  doPrint, { once: true });
      logo.addEventListener("error", doPrint, { once: true });
    } else {
      doPrint();
    }
  }

  // Helpers
  function setText(id, text) { const el = document.getElementById(id); if (el) el.textContent = text; }
  function setHtml(id, html) { const el = document.getElementById(id); if (el) el.innerHTML = html; }
  function formatReading(text) {
    if (!text) return "";
    return text.replace(/\n\n/g, '</p><p class="result-reading">').replace(/\n/g, "<br>");
  }

  // === Result screen show/hide ===

  function showResultScreen() {
    const rs = document.getElementById("screen-result");
    rs.classList.add("active");
    const scroll = rs.querySelector(".result-scroll");
    if (scroll) scroll.scrollTop = 0;
  }

  function hideResultScreen() {
    document.getElementById("screen-result").classList.remove("active");
  }

  function animateResultIn(rotationDonePromise) {
    const canvasWrap = document.querySelector(".result-phase__canvas-wrap");
    if (canvasWrap) setTimeout(() => canvasWrap.classList.add("visible"), 200);

    const done = rotationDonePromise || Promise.resolve();
    const chartModal = document.getElementById("chart-modal");
    const modalToggle = document.getElementById("chart-modal-toggle");
    if (chartModal) chartModal.style.display = "";
    if (modalToggle) modalToggle.style.display = "";

    init3DModalToggle();

    done.then(() => {
      if (chartModal) setTimeout(() => chartModal.classList.add("visible"), 300);
      setTimeout(() => {
        const chartArrow = document.getElementById("chart-scroll-arrow");
        if (chartArrow) {
          chartArrow.classList.add("visible");
          chartArrow.onclick = () => {
            const body = document.querySelector(".result-body");
            const scrollContainer = document.querySelector(".result-scroll");
            if (body && scrollContainer) {
              scrollContainer.scrollTo({ top: body.offsetTop, behavior: "smooth" });
            }
          };
        }
      }, 1500);
    });
  }

  function init3DModalToggle() {
    const modal = document.getElementById("chart-modal");
    const closeBtn = document.getElementById("chart-modal-close");
    const toggleBtn = document.getElementById("chart-modal-toggle");
    if (!modal || !closeBtn || !toggleBtn) return;

    closeBtn.addEventListener("click", () => {
      modal.classList.remove("visible");
      modal.classList.add("hidden");
      toggleBtn.classList.add("visible");
      // Hide the "鑑定結果を見る" scroll hint so the user can enjoy the
      // star view uninterrupted. Restored when the modal is reopened.
      const chartArrow = document.getElementById("chart-scroll-arrow");
      if (chartArrow) chartArrow.classList.remove("visible");
    });

    toggleBtn.addEventListener("click", () => {
      modal.classList.remove("hidden");
      modal.classList.add("visible");
      toggleBtn.classList.remove("visible");
      const chartArrow = document.getElementById("chart-scroll-arrow");
      if (chartArrow) chartArrow.classList.add("visible");
    });
  }

  function resetResultAnimations() {
    const cw = document.querySelector(".result-phase__canvas-wrap");
    if (cw) cw.classList.remove("visible");
    const scroll = document.querySelector(".result-scroll");
    if (scroll) scroll.scrollTop = 0;
    const chartArrow = document.getElementById("chart-scroll-arrow");
    if (chartArrow) chartArrow.classList.remove("visible");

    const chartModal = document.getElementById("chart-modal");
    if (chartModal) { chartModal.classList.remove("visible"); chartModal.classList.remove("hidden"); }
    const toggleBtn = document.getElementById("chart-modal-toggle");
    if (toggleBtn) toggleBtn.classList.remove("visible");
  }


  return {
    transitionScreen,
    populateDateSelects,
    setupCardSelection,
    selectCard,
    setupMultiCardSelection,
    selectMultiCards,
    showButton,
    renderResult,
    showResultScreen,
    hideResultScreen,
    animateResultIn,
    resetResultAnimations,
    buildAndPrint,
  };
})();
